import React from 'react';
import { createRoot } from 'react-dom/client';
import moment from "moment";

import * as commonFunc from 'scripts/common';
import Swal from "sweetalert2";

import ToolbarDate from 'components/ToolbarDate';
import CChart from 'components/CChart';

import CHtmlToOutput from 'components/CHtmlToOutput';
import CDataTable from "components/CDataTable";

import {
    Label,
    Row,
    Col,
    Card,
    CardBody,
    CardHeader,
    CardTitle, Button
} from "reactstrap";

const StatsLead = React.forwardRef(({ i18nManager, leadModels, filters, parentContext, hideToolbarDate, /*JSON ARGS*/ globalKey, showGlobalCard, objType, configs, periods, itemsLabel = "Éléments", slicerValue = 20 }, ref) => {

    const [displayStats, setDisplayStats] = React.useState(false);

    const [curDate, setCurDate] = React.useState(moment().format());
    const [endDate, setEndDate] = React.useState(moment().endOf("year").format());
    const [curPeriod, setCurPeriod] = React.useState("*");

    const [statsGlobalObj, setStatsGlobalObj] = React.useState();
    const [statsList, setStatsList] = React.useState();

    React.useEffect(() => {
        if (globalKey) getGlobalStats();
    }, [displayStats]);

    React.useEffect(() => {
        if (statsGlobalObj || !globalKey) getStats();
        if (statsGlobalObj && globalKey) getGlobalStats();
    }, [filters?.groupFilter, filters?.assignSiteFilter, filters?.serviceFilter]);

    React.useEffect(() => {
        getStats();
        if (statsGlobalObj && globalKey) getGlobalStats();
    }, [curPeriod, curDate, endDate]);


    React.useImperativeHandle(ref, () => ({
        isDisplayStats: () => displayStats,
        displayStats: () => {
            setDisplayStats(!displayStats);
        },
        getGlobalStats: () => statsGlobalObj
    }));


    function getGlobalStats() {
        setStatsGlobalObj(null);
        /*Swal.fire({
            title: props.i18nManager.t("gal_loading"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false
        });*/

        var args = { extraKey: globalKey, categ: "STATUS_EXTID", categoryId: -1, period: "*" };
        if (displayStats) {
            args.startDate = curDate;
            args.period = curPeriod;
            args.endDate = endDate;
        }

        if (filters?.groupFilter > 0) args.groupId = filters?.groupFilter;
        if (filters?.assignSiteFilter > 0) args.siteId = filters?.assignSiteFilter;
        if (filters?.serviceFilter > 0) args.serviceId = filters?.serviceFilter;
        if (filters?.categoryGroupKey) args.categoryGroupKey = filters?.categoryGroupKey;

        commonFunc.getMethod("../api/data/GetLeadSummary", args).then(response => {
            const dataStats = response.data;
            if (dataStats.isSuccess) {
                var statusSummary = dataStats.result;
                var statsObj = { count: 0 };

                statusSummary.forEach(obj => {
                    statsObj.count += obj.totalCount;
                    switch (obj.id) {
                        case 3005: statsObj.successCount = obj.totalCount; break;
                        case 3006: statsObj.loseCount = obj.totalCount; break;
                        case 3008: statsObj.waitingCount = obj.totalCount; break;
                        case 3001:
                        case 3002:
                        case 3003:
                        case 3004:
                        case 3007:
                        case 3009:
                            if (!statsObj.activeCount) statsObj.activeCount = 0;
                            statsObj.activeCount += obj.totalCount;
                            break;
                        default:
                            break;
                    }
                });

                setStatsGlobalObj(statsObj);
            }
        });
    }

    function getStats() {
        setStatsList(null);
        /*Swal.fire({
            title: props.i18nManager.t("gal_loading"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false
        });*/

        var asyncJobs = [];

        configs?.forEach(cfg => {
            var args = { ...cfg, startDate: curDate, period: curPeriod, endDate: endDate };
            delete args.cRowTag;
            delete args.cChartCfg;
            delete args.cTableCfg;

            if (filters?.groupFilter > 0) args.groupId = filters?.groupFilter;
            if (filters?.assignSiteFilter > 0) args.siteId = filters?.assignSiteFilter;
            if (filters?.serviceFilter > 0) args.serviceId = filters?.serviceFilter;
            if (filters?.categoryGroupKey) args.categoryGroupKey = filters?.categoryGroupKey;

            asyncJobs.push(commonFunc.getMethod("../api/data/GetLeadSummary", args).then((async response => {
                if (response.data) response.data.dataTarget = cfg.cChartCfg ? cfg.cChartCfg.dataTarget : cfg.cTableCfg.dataTarget;
                if (cfg.cChartCfg?.dataSort) {
                    switch (cfg.cChartCfg?.dataSort) {
                        case "name+id":
                            response.data.result = response.data.result.sort((a, b) => {
                                if (a.name === b.name) {
                                    return a.id - b.id;
                                }
                                return parseInt(a.name) - parseInt(b.name);
                            });
                            break;
                        default: break;
                    }
                }
                if (cfg.cChartCfg?.format) {
                    switch (cfg.cChartCfg?.format) {
                        case "date":
                            response.data.result.sort((a, b) => new Date(a.refName).getTime() - new Date(b.refName).getTime());
                            response.data.result.forEach((item) => {
                                item.refName = formatData(item.refName, (curPeriod === "M" || curPeriod === "W") ? "day" : "month");
                            });
                            break;
                        default: break;
                    }
                }
                return new Promise(resolve => {
                    resolve(response);
                });
            })).catch(error => {
                return new Promise((resolve) => {
                    resolve({ isSuccess: false, errorMessage: error });
                });
            }));
        });

        Promise.all(asyncJobs).then(results => {
            var err = 0;
            var sum = 0;
            var msgErr = "";

            var resultList = {};
            for (var i = 0; i < results.length; i++) {
                if (results[i] && results[i].data && results[i].data.isSuccess) {
                    sum += 1;
                    // resStr += dataAll[i].result.first_last_name + " " + dataAll[i].result.last_name + '/';
                    resultList[results[i].data.dataTarget] = results[i].data.result;
                } else {
                    err += 1;
                    if (results[i] && results[i].data) {
                        msgErr += i + " " + results[i].data.errorMessage + "\n";
                    } else {
                        msgErr += i + "\n";
                    }
                }
            }
            Swal.close();

            setStatsList(resultList);
            if (err === 0) {

            } else {
                var tot = 0;
                tot = err + sum;
                if (tot === configs.length) {
                    Swal.fire({
                        icon: "error",
                        title: "Echec",
                        html: "Echec de la récupération de certaines stats (" + err + "/" + sum + ") :<br>" + msgErr
                    });
                }
            }
        }, rej => {
            Swal.fire({
                icon: "error",
                title: "Erreur",
                html: "Erreur de la récupération des stats :<br>" + rej.message
            });
        }).catch(error => {
            Swal.fire({
                icon: "error",
                title: "Erreur",
                html: "Erreur de la récupération des stats :<br>" + error.message
            });
        });


    }


    function formatData(dataVal, format) {
        var value = dataVal;
        switch (format) {
            case "date":
                //moment(data, "YYYY-MM").format("MMM YYYY");
                break;
            case "day":
                value = moment(dataVal, "YYYY-MM-DD").format("DD/MM/YYYY");
                break;
            case "month":
                value = moment(dataVal, "YYYY-MM").format("MMM YYYY");
                break;
            case "i18n":
                //value = t((data.argumentsObj?.i18nSrc || "chartSrc.") + dataVal);
                break;
            default:
                break;
        }
        return value;
    }

    /****** GESTION DATE (ToolbarDate) ******/

    function selPreviousPeriod() {
        var curMoment = new moment(curDate);
        var view = curPeriod;
        var begin;

        switch (view) {
            case "D": //JOUR
                begin = curMoment.clone().subtract(1, 'days');
                break;

            case "L": //SEMAINE 5J
                begin = curMoment.clone().startOf('isoWeek').subtract(7, 'days');
                break;

            case "W": //SEMAINE
                begin = curMoment.clone().startOf('isoWeek').subtract(7, 'days');
                break;

            case "M": //MOIS /JOURS
                begin = curMoment.clone().startOf('month').subtract(1, 'days').startOf('month');
                break;

            case "Y": //ANNEE
                begin = curMoment.clone().startOf('year').subtract(1, 'days').startOf('year');
                break;
            default: break;
        }
        if (begin) {
            //setCurDate(begin.startOf('day').format());
            setCurDate(begin.utc(true).startOf('day').format());
        }
    }

    function datepickerChange(date, endChange) {
        if (!date) date = moment(curDate);

        if (!endChange) setCurDate(date.format());
        else setEndDate(date.format());
    }



    function selNextPeriod() {
        var curMoment = new moment(curDate);
        var view = curPeriod;
        var begin;

        switch (view) {
            case "D": //JOUR
                begin = curMoment.clone().add(1, 'days')
                break;

            case "L": //SEMAINE 5J
                begin = curMoment.clone().endOf('isoWeek').add(1, 'days');
                break;

            case "W": //SEMAINE
                begin = curMoment.clone().endOf('isoWeek').add(1, 'days');
                break;

            case "M": //MOIS /JOURS
                begin = curMoment.clone().endOf('month').add(1, 'days');
                break;

            case "Y": //ANNEE
                begin = curMoment.clone().endOf('year').add(1, 'days');
                break;
            default: break;
        }
        if (begin) {
            //setCurDate(begin.startOf('day').format());
            setCurDate(begin.utc(true).startOf('day').format());
        }
    }

    function getFormattedDate() {
        switch (curPeriod) {
            case "D": return moment(curDate).format("dddd DD MMMM YYYY");
            case "L": return moment(curDate).startOf('isoWeek').format("ddd DD MMMM YYYY [(S]W[)]") + " au " + moment(curDate).endOf('isoWeek').subtract(2, 'days').format("ddd DD MMMM YYYY [(S]W[)]");
            case "W": return moment(curDate).startOf('isoWeek').format("ddd DD MMMM YYYY [(S]W[)]") + " au " + moment(curDate).endOf('isoWeek').format("ddd DD MMMM YYYY [(S]W[)]");
            case "M": return moment(curDate).startOf('month').format("ddd DD MMMM YYYY") + " au " + moment(curDate).endOf('month').format("ddd DD MMMM YYYY");
            case "Y": return "Année " + moment(curDate).startOf('year').format("YYYY");
            case "C": return "Période personnalisée";
            case "*": return "Toutes Périodes";
            default: return "";
        }
    }

    /****** FIN GESTION DATE (ToolbarDate) ******/


    var altConfigs = {};
    if (periods) altConfigs.cPeriods = periods;
    altConfigs.updatePeriod = setCurPeriod;

    var cbObj = {
        sliceValue: function (val, index) {
            // Hide every 2nd tick label
            var label = this.getLabelForValue(val);
            return (label?.length > slicerValue ? (label.slice(0, slicerValue) + ".") : label);
        }
    };

    var rowConfigs = {};
    configs?.forEach((cfg) => {
        if (!rowConfigs[cfg.cRowTag]) rowConfigs[cfg.cRowTag] = [];
        rowConfigs[cfg.cRowTag].push(cfg);
    });

    const customPrint = () => {
        //CUSTOM PRINT
        var leadsContainer = document.querySelector(".leads-group");
        leadsContainer.remove();

        Swal.fire({
            title: i18nManager.t("gal_processing"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });

        //var targets = document.getElementsByClassName(targetValue.targetClass)?.length ? Array.from(document.getElementsByClassName(targetValue.targetClass)) : null;//content
        var targets = Array.from(document.querySelectorAll("#planHeader, .leads-stats"));//, .print-target
        const cards = Array.from(document.querySelectorAll(".print-target:not(.infos-target)"));
        //const cards = Array.from(document.querySelectorAll(".charts-container .row"));
        cards.forEach(target => {
            target.style.maxWidth = "860px";
            target.style.paddingLeft = "30px";
            target.style.paddingRight = "30px";
        });
        targets = [...targets, ...cards];
        if (targets) {
            //if (altValue) target.style["width"] = altValue;
            setTimeout(() => {
                var modalRoot = createRoot(document.createElement('div'));
                modalRoot.render(<CHtmlToOutput targets={targets} isWaiting coeff={1} outputType="pdf" compression="MEDIUM" pdfOrientation="l" callback={() => {
                    Swal.close();

                    cards.forEach(target => {
                        target.style.maxWidth = "";
                        target.style.paddingLeft = "";
                        target.style.paddingRight = "";
                    });

                    document.querySelector(".oskala-lead").append(leadsContainer);

                    if (modalRoot) {
                        modalRoot.unmount();
                        modalRoot = null;

                        //if (altValue) target.style["width"] = null;
                    }
                }} />);
            }, 500);
        }
        else {
            Swal.fire({
                icon: "error",
                title: i18nManager.t("gal_error"),
                html: i18nManager.t("gal_invalidArgs")
            });
        }
    };

    var printButton =
        <Button type="button" className="btn-sm" color="success" onClick={() => {
            if (showGlobalCard) {
                customPrint();
            }
            else printElement({
                "coeff": 1,
                "outputType": "pdf",
                "compression": "MEDIUM",
                "targetClass": "print-target"
            });
        }}><i className="fa fa-print"></i>Impression {itemsLabel}</Button>;


    var groupSelected;
    var groupF = parentContext?.groups?.filter(svc => svc.idSegment === filters?.groupFilter);
    if (groupF?.length) {
        groupSelected = groupF[0];
    }
    var assignSiteName;
    var siteF = parentContext?.sites?.filter(site => site.idSite === filters?.assignSiteFilter);
    if (siteF?.length) {
        assignSiteName = siteF[0].name;
    }
    var serviceName;
    var serviceF = parentContext?.services?.filter(group => group.idService === filters?.serviceFilter);
    if (serviceF?.length) {
        serviceName = serviceF[0].name;
    }

    return <>
        {(globalKey && showGlobalCard) ? <Card className="leads-stats w-100">
            <CardBody>
                <Row>
                    <Col onClick={() => { setDisplayStats(!displayStats); }}>
                        <Label>Total {itemsLabel}</Label>
                        <Label>{statsGlobalObj?.count || 0}</Label>
                    </Col>
                    <Col onClick={() => { setDisplayStats(!displayStats); }}>
                        <Label>Succès</Label>
                        <Label>{statsGlobalObj?.successCount || 0}</Label>
                    </Col>
                    <Col onClick={() => { setDisplayStats(!displayStats); }}>
                        <Label>Prospects transformés</Label>
                        <Label>{(((statsGlobalObj?.successCount / statsGlobalObj?.count) || 0) * 100).toFixed(2)}%</Label>
                    </Col>
                    <Col onClick={() => { setDisplayStats(!displayStats); }}>
                        <Label>En cours de traitement</Label>
                        <Label>{statsGlobalObj?.activeCount || 0}</Label>
                    </Col>
                    <Col onClick={() => { setDisplayStats(!displayStats); }}>
                        <Label>En attente d'intervention</Label>
                        <Label>{statsGlobalObj?.waitingCount || 0}</Label>
                    </Col>
                    <Col onClick={() => { setDisplayStats(!displayStats); }}>
                        <Label>Perdu</Label>
                        <Label>{statsGlobalObj?.loseCount || 0}</Label>
                    </Col>
                </Row>
            </CardBody>
        </Card> : ""}
        <div className="print-target infos-target py-1 d-none">
            <Card>
                <CardBody>
                    <span className="me-2 fs-6">Type : {groupSelected?.title || ""}</span>
                    <span className="me-2 fs-6">Asso. : {assignSiteName || "Global"}</span>
                    <span className="me-2 fs-6">Service : {serviceName}</span>
                </CardBody>
            </Card>
        </div>
        {displayStats ? <div className="stats-details">
            {!hideToolbarDate ? <ToolbarDate refreshContent={getStats} customTitle={getFormattedDate()} hideRefresh={true}
                currentPeriod={curPeriod}
                selPreviousPeriod={selPreviousPeriod}
                datepickerChange={datepickerChange}
                selNextPeriod={selNextPeriod}
                datepickerOpt={{ showWeeks: true, initialValue: moment(new Date()).utc().toDate(), initialEndValue: moment().endOf("year").endOf("day").toDate() }}
                customAddBtn={<div className="d-none"></div>} suppBtns={<button className="btn btn-success btn-icon rounded-circle" title={`Impression ${itemsLabel}`} onClick={() => { customPrint(); } }><i className="fa fa-print"></i></button>} {...altConfigs}></ToolbarDate> : ""}

            <div className="charts-container">
                {!statsList ? <div className="text-center"><i className="fa fa-circle-notch fa-spin fa-xl"></i></div> : ""}
                {/*printButton*/}
                {Object.keys(rowConfigs).map((rowCfgKey => {
                    return <Row className={`tag-${rowCfgKey}`}>
                        {rowConfigs[rowCfgKey].map(cfg => {
                            //Gestion function
                            var dataSrc;
                            if (cfg.cChartCfg) {
                                var labelSuffix = cfg.cChartCfg.chartOptions.plugins?.tooltip?.callbacks?.cLabelSuffix;

                                //Gestion function
                                if (cfg.cChartCfg.chartOptions?.scales?.x?.ticks?.cCallbackTag) cfg.cChartCfg.chartOptions.scales.x.ticks.callback = cbObj[cfg.cChartCfg.chartOptions.scales.x.ticks.cCallbackTag];

                                //Gestion de l'affichage tooltip si formattage
                                const formatLabel = (tooltipItem, dataItem) => {
                                    return formatData(tooltipItem.dataset.label, cfg.cChartCfg.chartOptions?.plugins?.tooltip?.callbacks?.label) + " : " + tooltipItem.formattedValue + (labelSuffix ? labelSuffix : "");
                                };
                                if (cfg.cChartCfg.chartOptions.plugins?.tooltip?.callbacks?.label) {
                                    cfg.cChartCfg.chartOptions.plugins.tooltip.callbacks.label = formatLabel;
                                }

                                //Gestion de l'affichage data sur graph
                                const formatPercentFromDs = (value, context) => {
                                    var sum = 0;
                                    if (dataObj.datasets?.length) {
                                        dataObj.datasets.forEach((ds) => {
                                            ds.data.forEach((item) => {
                                                sum += item;
                                            });
                                        });
                                        return ((value / sum) * 100).toFixed(2) + ' %';
                                    }
                                    else return value;
                                };
                                const formatPercentFromDsWN = (value, context) => {
                                    var sum = 0;
                                    if (dataObj.datasets?.length) {
                                        dataObj.datasets.forEach((ds) => {
                                            ds.data.forEach((item) => {
                                                sum += item;
                                            });
                                        });
                                        return context.dataset.label + " • " + ((value / sum) * 100).toFixed(2) + ' %';
                                    }
                                    else return value;
                                };
                                const formatPercentFromStackedDs = (value, context) => {
                                    var sum = 0;
                                    if (context.dataset.data?.length) {
                                        dataObj.datasets.forEach((ds) => {
                                            sum += ds.data[context.dataIndex];
                                        });
                                        return ((value / sum) * 100).toFixed(0) + '%';
                                    }
                                    else return value;
                                };
                                const formatPercentFromStackedDsWN = (value, context) => {
                                    var sum = 0;
                                    if (context.dataset.data?.length) {
                                        dataObj.datasets.forEach((ds) => {
                                            sum += ds.data[context.dataIndex];
                                        });
                                        return context.dataset.label + " • " + ((value / sum) * 100).toFixed(2) + ' %';
                                    }
                                    else return value;
                                };
                                const formatPercentFromCount = (value, context) => {
                                    var rows = dataObj?.cOrgRows;
                                    if (rows?.length && rows[0].totalCount) {
                                        return ((value / rows[0].totalCount) * 100).toFixed(2) + ' %';
                                    }
                                    else return value;
                                };

                                if (cfg.cChartCfg.chartOptions.plugins?.datalabels?.cFormatter) {
                                    switch (cfg.cChartCfg.chartOptions.plugins?.datalabels?.cFormatter) {
                                        case "formatPercentFromDs": cfg.cChartCfg.chartOptions.plugins.datalabels.formatter = formatPercentFromDs; break;
                                        case "formatPercentFromDsWN": cfg.cChartCfg.chartOptions.plugins.datalabels.formatter = formatPercentFromDsWN; break;
                                        case "formatPercentFromStackedDs": cfg.cChartCfg.chartOptions.plugins.datalabels.formatter = formatPercentFromStackedDs; break;
                                        case "formatPercentFromStackedDsWN": cfg.cChartCfg.chartOptions.plugins.datalabels.formatter = formatPercentFromStackedDsWN; break;
                                        case "formatPercentFromCount": cfg.cChartCfg.chartOptions.plugins.datalabels.formatter = formatPercentFromCount; break;
                                        default: break;
                                    }
                                }

                                //Gestion data source
                                dataSrc = statsList ? statsList[cfg.cChartCfg.dataTarget] : null;
                                if (dataSrc) {
                                    if (cfg.cChartCfg.dataProcess) {
                                        if (cfg.cChartCfg.dataProcess === "findsatisfaction" || cfg.cChartCfg.dataProcess === "findreco") {
                                            var optNb = {};
                                            var labelTab = cfg.cChartCfg.labelTab;
                                            if (objType === "surveystats") {
                                                labelTab = findLabelsFromModel(labelTab || {}, optNb);
                                            }

                                            var srcRows = dataSrc;

                                            var groupedRows = [];
                                            srcRows.forEach(row => {
                                                if (labelTab && labelTab[row.id] && labelTab[row.id][row.name]) {
                                                    var labelTabName = labelTab[row.id][row.name];
                                                    if ((cfg.cChartCfg.dataProcess === "findsatisfaction" && labelTabName.startsWith("Globalement")) || (cfg.cChartCfg.dataProcess === "findreco" && labelTabName.startsWith("Recommanderiez-vous"))) {
                                                        row.fullName = labelTabName;

                                                        manageGroup(groupedRows, row, labelTab, optNb, true);
                                                    }
                                                }
                                            });

                                            groupedRows.sort((a, b) => {
                                                if (a.sup_1 !== b.sup_1) {
                                                    return a.sup_1.toLowerCase().localeCompare(b.sup_1.toLowerCase());
                                                }
                                                return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
                                            });

                                            groupedRows.forEach((row, index) => {
                                                row.tag = row.name;
                                                row.name = row.fullName;
                                                delete row.fullName;

                                                row.refName = row.tag;
                                                if (parentContext?.sites) {
                                                    var siteFiltered = parentContext.sites.filter(site => site.idSite === parseInt(row.sup_1));
                                                    if (siteFiltered?.length) row.refName = siteFiltered[0].name;
                                                }
                                                row.srcCount = row.totalCount;
                                                row.totalCount = ((parseInt(row.totalCount) / parseInt(row.totalValue)) || 0) * 100;
                                            });

                                            itemsLabel = cfg.cChartCfg.dataProcess === "findsatisfaction" ? "Satisfaction" : "Recommandation";

                                            if (!cfg.cChartCfg.chartOptions.plugins) cfg.cChartCfg.chartOptions.plugins = { tooltip: { callbacks: {} } };
                                            if (!cfg.cChartCfg.chartOptions.plugins.tooltip) cfg.cChartCfg.chartOptions.plugins.tooltip = { callbacks: {} };
                                            if (!cfg.cChartCfg.chartOptions.plugins.tooltip.callbacks) cfg.cChartCfg.chartOptions.plugins.tooltip.callbacks = {};
                                            cfg.cChartCfg.chartOptions.plugins.tooltip.callbacks.label = (tooltipItem, dataItem) => {
                                                return tooltipItem.dataset.label + " : " + tooltipItem.formattedValue + " %";
                                            };


                                            dataSrc = groupedRows.sort((a, b) => a.refName.toLowerCase().localeCompare(b.refName.toLowerCase()));
                                        }
                                    }

                                    //Construction data chart.js
                                    var targetField = cfg.cChartCfg.dsProps.cOverrideField || "totalCount";
                                    var dataObj;
                                    if (cfg.cChartCfg.stacked) {
                                        dataObj = {
                                            labels: (() => {
                                                var labelList = {};
                                                dataSrc.forEach(obj => { labelList[obj.refName] = true; });
                                                return Object.keys(labelList);
                                            })(),
                                            datasets: (() => {
                                                var datasetList = {};

                                                //Création des datasets
                                                dataSrc.forEach(obj => {
                                                    if (!datasetList[obj.name]) { datasetList[obj.name] = { dataset: [], color: obj.altInfo, index: obj.sup_2, index2: obj.sup_1 }; }//TODO index
                                                });

                                                //Alimentation des datasets
                                                var lastName = null;
                                                var entityCount = 0;
                                                dataSrc.forEach(obj => {
                                                    if (lastName !== obj.refName) {
                                                        lastName = obj.refName;
                                                        if (entityCount > 0) {
                                                            //Alimentation des données vide dans les datasets restant
                                                            Object.keys(datasetList).forEach(dsKeyFill => {
                                                                var ds = datasetList[dsKeyFill];
                                                                if (ds.dataset.length < entityCount) ds.dataset.push(0);
                                                            });
                                                        }
                                                        entityCount++;
                                                    }
                                                    datasetList[obj.name].dataset.push(obj[targetField]);
                                                });
                                                //Alimentation des dernières données vide dans les datasets restant
                                                Object.keys(datasetList).forEach(dsKeyFill => {
                                                    var ds = datasetList[dsKeyFill];
                                                    if (ds.dataset.length < entityCount) ds.dataset.push(0);
                                                });

                                                return Object.keys(datasetList).sort((aKey, bKey) => {
                                                    var a = datasetList[aKey];
                                                    var b = datasetList[bKey];
                                                    if (a.index === b.index) {
                                                        return parseInt(a.index2) - parseInt(b.index2);
                                                    }
                                                    return parseInt(a.index) - parseInt(b.index);
                                                }).map(key => {
                                                    return {
                                                        "color": "#1A73E8",
                                                        "label": key,
                                                        "backgroundColor": datasetList[key].color,
                                                        "data": datasetList[key].dataset,
                                                        ...cfg.cChartCfg.dsProps
                                                    };
                                                });
                                            })()
                                        };
                                    }
                                    else {
                                        dataObj = {
                                            labels: dataSrc.map(obj => obj.refName),
                                            datasets: [
                                                {
                                                    "color": "#1A73E8",
                                                    "label": itemsLabel,
                                                    "backgroundColor": dataSrc.map(obj => obj.altInfo),
                                                    "data": dataSrc.map(obj => obj[targetField]),
                                                    ...cfg.cChartCfg.dsProps
                                                }
                                            ]
                                        };
                                    }

                                    return <Col key={cfg.cChartCfg.dataTarget} className="print-target">
                                        <Card className="w-100">
                                            <CardHeader>
                                                <CardTitle>{cfg.cChartCfg.title}</CardTitle>
                                            </CardHeader>
                                            <CardBody><CChart type={cfg.cChartCfg.type} redraw
                                                className="d-inline-block align-top"
                                                style={{ width: cfg.cChartCfg.width || "100%", height: cfg.cChartCfg.height || "250px" }}
                                                data={dataObj}
                                                options={cfg.cChartCfg.chartOptions}
                                                useLabelPlugin={cfg.cChartCfg.chartOptions.plugins.datalabels} />
                                            </CardBody>
                                        </Card>
                                    </Col>;
                                }
                                else return "";
                            }
                            else if (cfg.cTableCfg) {
                                //Gestion data source
                                dataSrc = statsList ? statsList[cfg.cTableCfg.dataTarget] : null;
                                if (dataSrc) {
                                    var srcRows = dataSrc;

                                    var optNb = {};
                                    var labelTab = cfg.cTableCfg.labelTab;
                                    if (objType === "surveystats") {
                                        labelTab = findLabelsFromModel(labelTab || {}, optNb);
                                    }

                                    var groupedRows = [];
                                    srcRows.forEach(row => {
                                        manageGroup(groupedRows, row, labelTab, optNb);
                                    });

                                    groupedRows.sort((a, b) => {
                                        if (a.sup_1 !== b.sup_1) {
                                            return a.sup_1.toLowerCase().localeCompare(b.sup_1.toLowerCase());
                                        }
                                        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
                                    });

                                    var globalRow, recommandationRow;
                                    var filteredRows = groupedRows.map((row, index) => {
                                        if (labelTab && labelTab[row.id] && labelTab[row.id][row.name]) {
                                            var labelTabName = labelTab[row.id][row.name];
                                            if (!labelTabName.startsWith("Globalement") && !labelTabName.startsWith("Recommanderiez-vous")) {
                                                return { id: index, name: (labelTabName || row.name), tag: row.name, srcId: row.id, grpId: filters?.groupFilter || 0, siteId: row.sup_1, percent: (parseInt(row.totalCount) / parseInt(row.totalValue)) || 0, optionsLength: row.optCount, count: row.totalValue, values: row.values };
                                            }
                                            else {
                                                if (labelTabName.startsWith("Globalement")) globalRow = row;
                                                if (labelTabName.startsWith("Recommanderiez-vous")) recommandationRow = row;
                                                return null;
                                            }
                                        }
                                        else return null;
                                    }).filter(row => row != null);

                                    //functionPanel={dtFunctionPanel}

                                    //return <CDataTable key={"stats" + objType} dtId={"tableStats" + objType} data={filteredRows} localConfig={dtConfig} tag={"DT_CARSSTATS"} config={dtModel} stamp={dataStamp}
                                    //    className={`table-striped table-hover nowrap`} style={{ fontSize: "90%" }} />;

                                    var lastGroup;
                                    return <div key={cfg.cTableCfg.dataTarget} className="mb-2">
                                        <Button type="button" className="btn-sm" onClick={() => {
                                            var srcRows = dataSrc;

                                            var optNb = {};
                                            var labelTab = cfg.cTableCfg.labelTab;
                                            if (objType === "surveystats") {
                                                labelTab = findLabelsFromModel(labelTab || {}, optNb);
                                            }

                                            var groupedRows = [];
                                            srcRows.forEach(row => {
                                                manageGroup(groupedRows, row, labelTab, optNb, true);
                                            });

                                            groupedRows.sort((a, b) => {
                                                if (a.sup_1 !== b.sup_1) {
                                                    return a.sup_1.toLowerCase().localeCompare(b.sup_1.toLowerCase());
                                                }
                                                return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
                                            });

                                            var exportFilteredRows = groupedRows.map((row, index) => {
                                                if (labelTab && labelTab[row.id] && labelTab[row.id][row.name]) {
                                                    var labelTabName = labelTab[row.id][row.name];
                                                    return { id: index, name: (labelTabName || row.name), tag: row.name, srcId: row.id, grpId: filters?.groupFilter || 0, siteId: row.sup_1, percent: (parseInt(row.totalCount) / parseInt(row.totalValue)) || 0, optionsLength: row.optCount, count: row.totalValue, values: row.values };
                                                }
                                                else return null;
                                            }).filter(row => row != null);

                                            var allRows = [...exportFilteredRows];
                                            exportToCsv(allRows, "Export " + itemsLabel);
                                        }}><i className="fa fa-file-excel"></i>Export {itemsLabel}</Button>
                                        {printButton}
                                        <div className="stats-progress-container py-1 print-target">
                                            {globalRow ? <div className="global-part d-flex">
                                                <div className="fw-bold" style={{ flex: "auto" }}>
                                                    <span className="fs-4" style={{ color: "#F68B1F" }}>{cfg.cTableCfg.title}</span>
                                                    <div className="float-end badge text-white p-2 fs-6" style={{ backgroundColor: "#F68B1F" }}>
                                                        <div>Satisfaction globale</div>
                                                        <div className="mt-1">{(((parseInt(globalRow.totalCount) / parseInt(globalRow.totalValue)) || 0) * 100).toFixed(2)}%</div>
                                                    </div>
                                                </div>
                                            </div> : ""}
                                            {filteredRows.map((row) => {
                                                var currentGroup = row.tag.split("-")[0];
                                                var supGroup = "";
                                                if (!lastGroup || lastGroup !== currentGroup) {
                                                    lastGroup = currentGroup;

                                                    var groupLabel = labelTab[row.srcId][lastGroup] || "";
                                                    var isBool = row.values?.length ? row.values[0].isBool : false;
                                                    supGroup = <div key={"g" + currentGroup} className="group-container">
                                                        <h6 className="text-success m-0 mt-3">{groupLabel}</h6>
                                                        <div className="d-flex">
                                                            <div className="w-50"></div>
                                                            {isBool ? <div className="fw-bold" style={{ flex: "auto" }}>
                                                                <span className="text-primary">Oui</span>
                                                                <span className="float-end text-primary bg-alpha">Non</span>
                                                            </div> : <div className="fw-bold" style={{ flex: "auto" }}>
                                                                <span className="text-success">Très satisfaisant</span>
                                                                <span className="float-end text-success bg-alpha">Satisfaisant</span>
                                                            </div>}
                                                            <span className="fw-bold ms-2 invisible">00.00%</span>
                                                        </div>
                                                    </div>;
                                                }

                                                return (<>
                                                    {supGroup}
                                                    <div key={"item" + row.id} className="d-flex progress-container">
                                                        <div className="w-50">{row.name}</div>
                                                        <div className="progress" style={{ flex: "auto" }}>
                                                            {row.values.filter(valObj => valObj.isProgress).map((valObj, index) => {
                                                                var progression = (valObj.count / row.count);
                                                                return <div key={index + (valObj.isMax ? "M" : "")} className={`progress-bar ${valObj.isBool ? "bg-primary" : "bg-success"} ${valObj.isMax ? "" : "bg-alpha"}`} title={(progression * 100).toFixed(2) + "%"} role="progressbar" aria-valuenow={(progression * 100)} aria-valuemin="0" aria-valuemax="100" style={{ width: (progression * 100) + "%" }} ></div>;
                                                            })}
                                                        </div>
                                                        <span className="fw-bold ms-2" style={{ width: "60px" }}>{(row.percent * 100).toFixed(2) + "%"}</span>
                                                    </div>
                                                </>);
                                            })}
                                            {recommandationRow ? <div className="reco-part d-flex mt-2">
                                                <div className="fw-bold" style={{ flex: "auto" }}>
                                                    <div className="float-start badge text-white p-2 fs-6" style={{ backgroundColor: "#F68B1F"}}>
                                                        <div>Je recommande l'ADMR</div>
                                                        <div className="mt-1">{(((parseInt(recommandationRow.totalCount) / parseInt(recommandationRow.totalValue)) || 0) * 100).toFixed(2)}%</div>
                                                    </div>
                                                </div>
                                            </div> : ""}
                                        </div>
                                    </div>;


                                }
                                else return "";
                            }
                            else return "";
                        })}
                    </Row>;
                }))}
            </div>
        </div> : ""}
    </>;


    function findLabelsFromModel(srcLabelTab, srcOptNb) {
        var optNb = srcOptNb || {};

        var serviceModifier = filters?.serviceFilter > 0 ? "_" + filters?.serviceFilter : "";
        var groupModifier = filters?.groupFilter > 0 ? "_" + filters?.groupFilter : "";
        var leadModel = leadModels ? (leadModels["LEAD_SURVEY" + groupModifier + serviceModifier] || leadModels["LEAD_SURVEY" + serviceModifier]) : null;

        //TODO : Voir si gestion de plusieurs service...
        var serviceID = filters?.serviceFilter;

        var labelTab = {};
        leadModel.templates.forEach(template => {
            template.categories.forEach(category => {
                category.headers.forEach(header => {
                    header.groups.forEach(group => {
                        var lastGroupLabel;
                        var lastLabel;
                        group.items.forEach(item => {
                            if (item.objType === "textview") {
                                lastLabel = item.title;
                                if (group.items.length === 3 && item.title?.indexOf("•") >= 0) lastGroupLabel = item.title;
                            }
                            if (item.bindPropResult?.toLowerCase().startsWith("extras.") && item.objType === "radio") {
                                var targetKey = item.bindPropResult.replace("Extras.", "").replace("extras.", "");
                                targetKey = targetKey.charAt(0).toLowerCase() + targetKey.slice(1);
                                if (lastGroupLabel) {
                                    if (!labelTab[serviceID]) labelTab[serviceID] = {};
                                    labelTab[serviceID][targetKey.split("-")[0]] = lastGroupLabel;
                                }
                                if (lastLabel) {
                                    if (!labelTab[serviceID]) labelTab[serviceID] = {};
                                    labelTab[serviceID][targetKey] = lastLabel;
                                }

                                if (!optNb[serviceID]) optNb[serviceID] = {};
                                optNb[serviceID][targetKey] = (item.options?.length || 0);

                                lastLabel = null;
                            }
                        });
                    });
                });
            });
        });
        labelTab = commonFunc.mergeDeep({}, labelTab, srcLabelTab); //Override labels

        return labelTab;
    }

    function manageGroup(groupedRows, row, labelTab, optNb, withSup1) {
        var curRow;
        var subVal;
        var containRow = groupedRows.filter(gRow => gRow.name === row.name && (!withSup1 || gRow.sup_1 === row.sup_1));
        if (containRow.length) {
            curRow = containRow[0];

            var existingVal = curRow.values.filter(subVal => subVal.value === row.refName);
            if (existingVal?.length) {
                subVal = existingVal[0];
                subVal.count += row.totalCount;
            }
            else {
                subVal = { count: row.totalCount, value: row.refName };
                curRow.values.push(subVal);
            }
        }
        else {
            subVal = { count: row.totalCount, value: row.refName };
            curRow = { ...row, values: [subVal] };
            delete curRow.refName;
            curRow.totalCount = 0;
            curRow.optCount = optNb[row.id] ? (optNb[row.id][row.name] || 0) : 0;
            if (!withSup1) delete curRow.sup_1;
            groupedRows.push(curRow);
        }

        //Test valeur spécifiques
        if (!(parseInt(row.refName) === 8192 || parseInt(row.refName) === 0)) curRow.totalValue += row.totalCount;

        if (curRow.optCount > 0 && curRow.optCount <= 4) {//Vérification du nombre d'option pour définir "Niveau Satisf." OU "Oui/Non" (<=4)
            subVal.isBool = true;
            if (parseInt(row.refName) === 4) {//Détermine si on le gère dans la progressbar ou non
                curRow.totalCount += row.totalCount;//Oui
                subVal.isProgress = true;
                subVal.isMax = true;
            }
        }
        else if (parseInt(row.refName) === 16 || parseInt(row.refName) === 8) {//Détermine si on le gère dans la progressbar ou non
            curRow.totalCount += row.totalCount;//Très+Satisfaisant
            subVal.isProgress = true;
            subVal.isMax = parseInt(row.refName) === 16;
        }
    }


    //****** EXPORT ******/

    function printElement(targetValue) {
        Swal.fire({
            title: i18nManager.t("gal_processing"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });

        //var targets = document.getElementsByClassName(targetValue.targetClass)?.length ? document.getElementsByClassName(targetValue.targetClass)[0] : null;//content
        var targets = document.getElementsByClassName(targetValue.targetClass)?.length ? Array.from(document.getElementsByClassName(targetValue.targetClass)) : null;//content
        targets.forEach(target => {
            target.style.maxWidth = "860px";
            target.style.paddingLeft = "30px";
            target.style.paddingRight = "30px";
        });

        if (targets) {
            //if (altValue) target.style["width"] = altValue;
            setTimeout(() => {
                var modalRoot = createRoot(document.createElement('div'));
                modalRoot.render(<CHtmlToOutput targets={targets} isWaiting {...targetValue} callback={() => {
                    Swal.close();

                    targets.forEach(target => {
                        target.style.maxWidth = "";
                        target.style.paddingLeft = "";
                        target.style.paddingRight = "";
                    });

                    if (modalRoot) {
                        modalRoot.unmount();
                        modalRoot = null;

                        //if (altValue) target.style["width"] = null;
                    }
                }} />);
            }, 500);
        }
        else {
            Swal.fire({
                icon: "error",
                title: i18nManager.t("gal_error"),
                html: i18nManager.t("gal_invalidArgs")
            });
        }
    }


    function downloadFile(fileName, data) {
        const downloadLink = document.createElement('a');
        downloadLink.download = fileName;
        const url = URL.createObjectURL(data);
        downloadLink.href = url;
        downloadLink.click();
        URL.revokeObjectURL(url);
    }

    async function exportToCsv(rows, fileName) {
        if (rows.length) {
            const exportArgs = [{ label: "ID Question", target: "tag" }, { label: "Question", target: "name" }, { label: "ID Groupe", target: "grpId" }, { label: "Groupe", target: "grpId", i18n: true }, { label: "ID Service", target: "srcId" },
                { label: "Service", target: "srcId", i18n: true }, { label: "ID Asso.", target: "siteId" }, { label: "Asso.", target: "siteId", i18n: true }, { label: "Pourcentage", target: "percent" },
                { label: "Détails", target: "values", childs: ["16", "8", "4", "2", "8192", "0"], prevent: true }];

            var finalFileName = fileName;
            var extNameGroup = false;
            var extNameSite = false;
            var extNameSvc = false;

            var subHeadAdded = false;
            const head = exportArgs.map(args => args.prevent ? null : args.label).filter(label => label != null);
            const body = rows.map(obj => {
                var rowElems = [];
                exportArgs.forEach(args => {
                    var value = obj[args.target];
                    if (args.i18n) {
                        switch (args.target) {
                            case "grpId":
                                if (parentContext?.groups) {
                                    var groupFiltered = parentContext.groups.filter(svc => svc.idSegment === parseInt(value));
                                    if (groupFiltered?.length) value = groupFiltered[0].title;
                                    if (!extNameGroup && groupSelected) {
                                        extNameGroup = true;
                                        finalFileName = finalFileName + " " + groupSelected.comments;
                                    }
                                }
                                break;
                            case "srcId":
                                if (parentContext?.services) {
                                    var serviceFiltered = parentContext.services.filter(svc => svc.idService === parseInt(value));
                                    if (serviceFiltered?.length) value = serviceFiltered[0].name;
                                    if (!extNameSvc && serviceName) {
                                        extNameSvc = true;
                                        finalFileName = finalFileName + " " + serviceName;
                                    }
                                }
                                break;
                            case "siteId":
                                if (parentContext?.sites) {
                                    var siteFiltered = parentContext.sites.filter(svc => svc.idSite === parseInt(value));
                                    if (siteFiltered?.length) value = siteFiltered[0].name;
                                    if (!extNameSite && assignSiteName) {
                                        extNameSite = true;
                                        finalFileName = finalFileName + " " + assignSiteName;
                                    }
                                }
                                break;
                            case "status":
                                //draft / confirmed / cancelled / pending
                                var convertionStatus = { draft: "Brouillon", confirmed: "Soldé", cancelled: "Annulée", pending: "En attente" }
                                value = convertionStatus[value];
                                break;
                            case "payment":
                                //collect / paid / acompte / refund
                                var convertionPayment = { collect: "À encaisser", paid: "Facturé", acompte: "Acompte", refund: "Remboursé" }
                                value = convertionPayment[value];
                                break;
                            default:
                                break;
                        }
                    }
                    if (args.target === "percent") value = (parseFloat(value) * 100).toFixed(2) + "%";
                    if (args.target === "values") {
                        if (!subHeadAdded) {
                            head.push(...args.childs);
                            subHeadAdded = true;
                        }
                        args.childs?.forEach(subHead => {
                            var subValFiltered = value.filter(subVal => subVal.value === subHead);
                            if (subValFiltered?.length) {
                                rowElems.push(JSON.stringify(subValFiltered[0].count ?? ""));
                            }
                            else rowElems.push("");
                        });
                        return;
                    }
                    rowElems.push(JSON.stringify(value ?? ""));
                });

                return rowElems.join(";");
            });
            /*const head = Object.keys(rows[0]);
            const body = rows.map(obj =>
                head.map(h => JSON.stringify(obj[h] ?? "")).join(";")
            );*/
            const foot = [];
            const content = [head.join(";"), ...body, ...foot.join(";")].join("\n");

            downloadFile(finalFileName || fileName, new Blob(["\ufeff", content], { type: 'text/csv;charset=utf-8;' }));//BOM doit être renseigné pour certaines compatibilités
        }
    }
});

export default StatsLead;